import {Application} from './application.model';
import {WebhookBanner} from '@app/views/admin/application-settings/models/provisioning.model';

export class ApplicationGalleryModel extends Application {
    public pendingRequestCount: number;
    public syncMode: string;
    public vendorName: string;
    public isDefaultApplication: boolean;
    public integrationId: string;
    public show: boolean;
    public modesString: string;
    public webhookBanner: WebhookBanner;

    constructor(isDefaultApplication: boolean, pendingRequestCount?: number, syncMode?: string, vendorName?: string) {
        super();
        this.isDefaultApplication = isDefaultApplication;
        this.pendingRequestCount = pendingRequestCount;
        this.syncMode = syncMode;
        this.vendorName = vendorName;
    }
}
